export function setTotalRincian(data) {
  return (dispatch) => {
    dispatch({type: 'SET_TOTAL_RINCIAN', payload: data});
  };
}

export function setHasilRincian(data) {
  return (dispatch) => {
    dispatch({type: 'SET_HASIL_RINCIAN', payload: data});
  };
}

export function addDataNoSeal(data) {
  return (dispatch) => {
    dispatch({type: 'ADD_DATA_NO_SEAL', payload: data});
  };
}

export function setMataUangList(data) {
  return (dispatch) => {
    dispatch({type: 'SET_MATA_UANG_LIST', payload: data});
  };
}

export function resetAddDataNoSeal() {
  return (dispatch) => {
    dispatch({type: 'RESET_ADD_DATA_NO_SEAL', payload: [{}]});
  };
}

export function resetMataUangList() {
  return (dispatch) => {
    dispatch({type: 'RESET_MATA_UANG_LIST', payload: [{}]});
  };
}

export function resetHasilRincian() {
  return (dispatch) => {
    dispatch({type: 'SET_HASIL_RINCIAN', payload: []});
  };
}

export function setFormUang(data) {
  return (dispatch) => {
    dispatch({type: 'SET_FORM_UANG', payload: data});
  };
}

export function setTotalAmount(data) {
  return (dispatch) => {
    dispatch({type: 'SET_TOTAL_AMOUNT', payload: data});
  };
}

export function resetTotalAmount() {
  return (dispatch) => {
    dispatch({type: 'RESET_TOTAL_AMOUNT', payload: 0});
  };
}
